import {closeModal, pathIs, url} from "../../utilities";
import {toastAlert} from "../../toastAlert";
import {confirmModal} from "../../confirmModal";
import axios from "axios";
import * as $ from "jquery";
import {EpMap} from "../../map/map";
import {Feature} from "ol";
import {Point} from "ol/geom";
import {fromLonLat} from "ol/proj";
import {EpHeatmap} from "../../map/layers/heatmap";
import {EpLayer} from "../../map/layers/layer";
import {
    farInventoryLocationStyle,
    inventoryLocationStyle
} from "../../map/styles/inventory-locations";
import {LayerControl} from "../../map/controls/LayerControl";
import {show} from "./show";
import {calculateAreas} from "./common";
import {locationsManagementPage} from "./locations";
import {farInventoryTrackedRouteStyle, inventoryTrackedRouteStyle} from "../../map/styles/inventory-tracked-routes";
import {EpInventoryLocationPoints} from "../../map/layers/inventory-location-points";
import {EpInventoryLocations} from "../../map/layers/inventory-locations";
import {animal} from "./animal";
import {EpHuntingDevicesLayer} from "../../map/layers/group-hunting-devices";
import {HunterPointsLayer} from "../../map/layers/hunter-points";
import {InventoryLocationInteractionBeatersLine} from "./locations/interactions/beaters-line";
import {InventoryLocationInteractionObserversLine} from "./locations/interactions/observers-line";
import {InventoryLocationInteractionsHandler} from "./locations/interactions";

export const group_hunting_page = () => {

    const body = $('body');

    // locations page
    if (pathIs("*\/group-hunting\/[0-9]*\/edit\/locations*")) {
        locationsManagementPage()
    }

    if (pathIs("*\/group-hunting\/[0-9]*\/hunters*")) {
        animal()
    }

    // page
    if (
        pathIs(".*\/group-hunting\/[0-9]*\/$", false) ||
        pathIs(".*\/group-hunting\/[0-9]*\?$", false) ||
        pathIs(".*\/group-hunting\/[0-9]{1,20}$", false)
    ) {
        show();
    }

    if (pathIs("*\/group-hunting\/observers*")) {
        $('body').on('click', '.btnChooseUser', function () {
            if ($(this).closest('table').hasClass('users-to-merge')) {
                $("#form_user_to_merge").val($(this).data('login'));
            } else {
                $("#form_final_user").val($(this).data('login'));
            }
        })

        $('.users-to-merge, .final-users').DataTable({
            deferRender: true,
            data: window._users,
            columnDefs: [
                {
                    targets: 0,
                    data: 'login'
                },
                {
                    targets: 1,
                    data: 'display_name'
                },
                {
                    targets: 2,
                    data: 'associations'
                },
                {
                    targets: 3,
                    data: 'id',
                    render: function (data, type, row) {
                        return `
                        <button type="button" class="btn btn-sm btn-primary btnChooseUser"
                                data-bs-dismiss="modal" aria-label="Close"
                                data-type=""
                                data-login="${row.login}">
                                Wybierz
                        </button>
                    `
                    }
                }
            ]
        })
    }

    $("#availableMembersList").DataTable({
        "order": [[2, "asc"]],
        "stateSave": false,
    });

    if($("#availableMembersList").length > 0) {
        $("#addHuntingLeaders").submit(function (e) {
            e.preventDefault();

            let inputs = $("#availableMembersList").DataTable().$('input');

            for(let input of inputs) {

                if($(input).prop('checked') === true && $(input).val() !== "") {
                    $(this).append(`<input type="hidden" name="users_id[${$(input).val()}]" value="${$(input).val()}" />`);
                }
            }
            this.submit();
        })
    }

    if($("#availableTypesList").length > 0) {
        $("#addHuntingTypes").submit(function (e) {
            e.preventDefault();

            let inputs = $("#availableTypesList").DataTable().$('input');

            for(let input of inputs) {

                if($(input).prop('checked') === true && $(input).val() !== "") {
                    $(this).append(`<input type="hidden" name="types_id[${$(input).val()}]" value="${$(input).val()}" />`);
                }
            }
            this.submit();
        })
    }

    $("#availableTypesList").DataTable({
        "order": [[1, "asc"]],
        "stateSave": false,
    });

    $("#allowedParticipants").DataTable({
        "order": [[1, "asc"]],
        "stateSave": false,
    });

    $("#groupHuntingLeaders").DataTable({
        "order": [[1, "asc"]],
        "stateSave": false,
    });

    $("#groupHuntingTypes").DataTable({
        "order": [[0, "asc"]],
        "stateSave": false,
    });


    /// Variables
    let observations = typeof window._observations == 'undefined' ? [] : JSON.parse(window._observations);

    /// Tables
    const locationsTable = $('#locationsTable').DataTable();
    const templatesTable = $('#inventoryTemplatesTable');
    const itemsTable = $('#observedItemsTable');

    if (itemsTable.length > 0) {
        let filterColumns = [];
        if(window._is_forest_address_to_select) {
            const forestries = [];
            for(const observation of observations) {
                if(observation.subarea && observation.subarea.forestry && forestries.findIndex(f => f.id === observation.subarea.forestry.id) === -1) {
                    forestries.push(observation.subarea.forestry)
                }
            }

            filterColumns.push({
                index: 2,
                title: 'Leśnictwo',
                values: forestries.map(forestry => (
                    {
                        text: forestry.code,
                        value: forestry.full_code,
                        custom: (settings, searchData, index, rowData) => {
                            return rowData[2].startsWith(forestry.full_code);
                        }
                    }
                ))
            })
        }

        itemsTable.DataTable({
            filters: {
                columns: filterColumns
            },
            responsive: {
                details: {
                    renderer: function (api, rowIdx, columns) {
                        let hidden = columns.filter(column => column.hidden);

                        const ul = $('<ul class="dtr-details"></ul>')

                        let rowNode = $(api.row(rowIdx).node());
                        let controlNode = rowNode.find('[data-app-expand="child"]');

                        if (hidden.length === 1 && hidden[0].title === 'Uwagi') {
                            if (!hidden[0].data.length) {
                                return false;
                            }

                            if (!controlNode.hasClass('dtr-custom-control')) {
                                controlNode.addClass('dtr-custom-control');
                            }

                            $('#btnExpandComments').show();

                            if (!controlNode.hasClass('dtr-custom-control-expanded')) {
                                return false;
                            }
                        } else {
                            controlNode.removeClass('dtr-custom-control');
                            $('#btnExpandComments').hide();
                        }

                        for (let column of hidden) {
                            if (column.title === 'Uwagi' && column.data.length === 0) {
                                continue;
                            }

                            ul.append(`
                                <li data-dtr-index="${column.index}" data-dt-row="${rowIdx}" data-dt-column="${column.index}">
                                    <span class="dtr-title">${column.title}</span>
                                    <span class="dtr-data">${column.data}</span>
                                </li>
                            `)
                        }

                        return $('<table />').append(ul);
                    },
                }
            },
        })

        itemsTable.on( 'draw.dt', function () {
            $('[data-bs-toggle="tooltip"]').each(function() {
                new bootstrap.Tooltip(this)
            })
        } );

        body.on('click', '[data-app-expand="child"]', function () {
            if (!$(this).hasClass('dtr-custom-control')) {
                return;
            }

            if ($(this).hasClass('dtr-custom-control-expanded')) {
                $(this).removeClass('dtr-custom-control-expanded')
            } else {
                $(this).addClass('dtr-custom-control-expanded')
            }

            itemsTable.DataTable().api().draw(false);
        })

        body.on('click', '#btnExpandComments', function () {
            $('.dtr-custom-control').each(function () {
                if (!$(this).hasClass('dtr-custom-control-expanded')) {
                    $(this).click();
                }
            })
        })

        itemsTable.DataTable().api().search('').draw();

        $('#observedItemsTable_length').append($('#btnExpandComments'));
    }

    templatesTable.DataTable({
        responsive: {
            details: {
                display: $.fn.dataTable.Responsive.display.childRow,
                type: 'inline'
            }
        },
    })


    body.on('click', '.btnDeleteLocation', async function () {
        let confirm = await confirmModal('Czy jesteś pewny/a, że chcesz usunąć ten miot?', {color: 'danger'});
        if (!confirm) return;

        try {
            const response = await axios.post(url(`api/group-hunting/locations/${$(this).data('id')}/delete`));

            if (response.data.code !== 200) {
                throw new Error();
            }

            let row = locationsTable.$(`tr[data-id=${$(this).data('id')}]`)
            locationsTable.api().row(row).remove().draw();

            toastAlert('Pomyślnie usunięto miot');
        } catch (err) {
            toastAlert('Wystąpił błąd podczas próby usunięcia miotu', {type: 'danger'})
        }
    })

    $("#editInventory select[name='inventory_type_id']").change(function () {
        let id = $(this).val();
        let modal = $('#typeDescriptionModal');

        if (modal.length > 0) {
            modal.find('.type-description').hide();
            modal.find('.type-description[data-id="' + id + '"]').show();
        }

        let videoId = window._tutorials[$(this).val()];
        $('.btnVideotutorial').attr('href', `https://www.youtube.com/embed/${videoId}`)
    }).change();

    $("[name='area']").on('input', function () {
        $(this).closest('.col-12').find('[name="area_changed_manually"]').val(1);

        if ($(this).val().length === 0) {
            $(this).closest('.col-12').find('[name="area_changed_manually"]').val(0);
        }
    })

    $('form#addUser select[name="type_id"]').change(function () {
        let elements = $(this)
            .closest('form')
            .find('[name="last_name"], [name="email"], [name="phone_number"], [name="address_line_1"], [name="address_line_2"], [name="postal_code"], [name="city"], [name="is_inventories_management_role"], [name="is_group_hunting_management_role"]')
            .closest('.input-group, .form-check')
            .parent()
            .closest('div');

        if (parseInt($(this).val()) === 10) {
            elements.hide();

            $(this).closest('form').find('label[for="addUser_first_name"]').text('Nazwa')
            $(this).closest('form').find('[name="first_name"]').attr('placeholder', 'Nazwa')
        } else {
            $(this).closest('form').find('label[for="addUser_first_name"]').text('Imię')
            $(this).closest('form').find('[name="first_name"]').attr('placeholder', 'Imię')
            elements.show();
        }
    }).trigger('change');

    calculateAreas();

    // Map
    let mapContainer = $("#map");
    if (mapContainer.length > 0) {
        const changeMapSize = () => {
            let height = 400;
            mapContainer.height(height - 32);
        }
        changeMapSize();

        let epMap = new EpMap({
            target: 'map',
            ruler: true,
            hideLabelsIfNecessary: true,
            fitSectorsAndBoundariesAfterInit: false
        });
        epMap.addSectorsLayer();

        if (typeof window._locations != 'undefined') {
            let locations = JSON.parse(window._locations);

            // locations layer
            let locationsLayer = new EpInventoryLocations(epMap.map);
            locationsLayer.setStyle(inventoryLocationStyle, farInventoryLocationStyle);
            locationsLayer.name = 'locations';
            locationsLayer.title = 'Obszary';

            epMap.changeStyleUnderZoom(locationsLayer)

            let locationPointsLayer = new EpInventoryLocationPoints();
            let locationDevicesLayer = new EpHuntingDevicesLayer();
            let locationHuntersLayer = new HunterPointsLayer();

            for (let location of locations) {
                locationsLayer.addFeature(location.coordinates, {
                    fields: {
                        name: location.name
                    }
                });


                // add points
                for(const point of location.points) {
                    locationPointsLayer.addFeature(
                        [point.longitude, point.latitude],
                        {fields: {name: point.name}}
                    )
                }

                for(const point of location.devices) {
                    locationDevicesLayer.addFeature(
                        [point.longitude, point.latitude],
                        {fields: {name: point.name, device_type_id: point.device_type_id}}
                    )
                }

                for(const point of location.hunters) {
                    locationHuntersLayer.addFeature(
                        [point.longitude, point.latitude],
                        {fields: {name: point.name, device_type: point.type}}
                    )
                }

            }

            epMap.addCustomLayer(locationsLayer);
            epMap.addCustomLayer(locationPointsLayer);
            epMap.addCustomLayer(locationDevicesLayer);
            epMap.addCustomLayer(locationHuntersLayer);
            locationsLayer.fitInView();

            if(locations.length >0){

                const beatersSpotsHandler = new InventoryLocationInteractionBeatersLine({
                    epMap: epMap,
                    locationChosen: locations[0]
                });

                beatersSpotsHandler.updateSpotsShow();

                const huntersSpotsHandler = new InventoryLocationInteractionObserversLine({
                    epMap: epMap,
                    locationChosen: locations[0]
                });

                huntersSpotsHandler.updateSpotsShow();
            }

        }


        epMap.addBoundariesLayer();

        // enable bdl
        if (typeof LayerControl.getLayerSavedVisibility('bdl-0') == 'undefined') {
            LayerControl.setLayerSavedVisibility('bdl-0', true)
        }

        if (typeof LayerControl.getLayerSavedVisibility('bdl-1') == 'undefined') {
            LayerControl.setLayerSavedVisibility('bdl-1', true)
        }

        if(typeof window._locations != 'undefined') {
            const locations = JSON.parse(window._locations);

            const districtsLoaded = [];
            for(const location of locations) {
                if(
                    location.district &&
                    !districtsLoaded.includes(location.district.id) &&
                    location.district.coordinates
                ) {
                    districtsLoaded.push(location.district.id);
                    epMap.boundaries.addFeature(location.district.coordinates);
                }
            }

            epMap.boundaries.fitInView();
        }

        if (typeof window._sectors != 'undefined') {
            epMap.sectors.addSectorsFromObject(JSON.parse(window._sectors));
        }

    }

    $('#save-button').on('click', function (e) {
        location.reload();
    });

}
